import React from 'react';
import { UrgencyBar, HeroSection, PainRecognition } from '../components/sections/HeroSections';
import { AgitationSection, MechanismSection } from '../components/sections/ProblemSections';
import { ProductPresentation, TomosSection, ResultsSection } from '../components/sections/SolutionSections';
import { BonusesSection, PricingCTA } from '../components/sections/OfferSections';
import { TestimonialsSection, GuaranteeSection, FAQSection, FinalCTA, Footer } from '../components/sections/TrustSections';
export default function LandingPage() {
  return <div className="min-h-screen bg-cream font-body text-brown-text selection:bg-pink-primary selection:text-white" data-id="element-272" data-mp="263kbfpq3nrov">
      <UrgencyBar data-id="element-273" data-mp="2fzno3pikv8q2" />

      <main data-id="element-274" data-mp="2fz45s7p0mibi">
        <HeroSection data-id="element-275" data-mp="2fzdwxylsqvis" />
        <PainRecognition data-id="element-276" data-mp="2g06v4b6owcpb" />
        <AgitationSection data-id="element-277" data-mp="2fxkrgmmx6hcd" />
        <MechanismSection data-id="element-278" data-mp="qkfw4e7t7eh6" />
        <ProductPresentation data-id="element-279" data-mp="qlqv80qb7y1y" />
        <TomosSection data-id="element-280" data-mp="qkz9dhmileov" />
        <ResultsSection data-id="element-281" data-mp="llmficx877cs" />
        <BonusesSection data-id="element-282" data-mp="lmeablj01120" />
        <PricingCTA data-id="element-283" data-mp="lmxqoxt03hdx" />
        <TestimonialsSection data-id="element-284" data-mp="lnpehmgcwatn" />
        <GuaranteeSection data-id="element-285" data-mp="2zj6y737qtl4o" />
        <FAQSection data-id="element-286" data-mp="2zjykfnfga6ia" />
        <FinalCTA data-id="element-287" data-mp="2zki4paskp6zh" />
      </main>

      <Footer data-id="element-288" data-mp="2zh41y1fzyvri" />
    </div>;
}